import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Phone, Globe, ShieldCheck, Menu, X, LogOut } from "lucide-react";
import { useAdmin } from "@/context/AdminContext";

const NAV = [
  { label: "Home", to: "/" },
  { label: "Online Services", to: "/#services" },
  { label: "Booking Calendar", to: "/booking-calendar" },
  { label: "Booking Status", to: "/booking-status" },
  { label: "Admin Portal", to: "/admin" },
];

export const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { admin, logout } = useAdmin();
  const [open, setOpen] = React.useState(false);

  return (
    <header className="sticky top-0 z-50" data-testid="site-header">
      {/* Top utility bar */}
      <div className="bg-[#50000E] text-amber-100 text-xs">
        <div className="max-w-7xl mx-auto px-4 py-1.5 flex items-center justify-between">
          <div className="flex items-center gap-2 font-medium">
            <Phone className="w-3.5 h-3.5 text-[#DAA520]" />
            <span>Call Center (24X7): 155 257</span>
          </div>
          <div className="hidden sm:flex items-center gap-4">
            <span className="flex items-center gap-1"><Globe className="w-3.5 h-3.5" /> English</span>
            <span className="text-[#DAA520]">Om Namo Venkatesaya</span>
          </div>
        </div>
      </div>

      {/* Brand header */}
      <div className="bg-gradient-to-r from-[#7A0016] via-[#8d0019] to-[#7A0016] border-b-2 border-[#DAA520]">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3" data-testid="brand-logo">
            <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center shadow-lg ring-2 ring-[#DAA520]/60 overflow-hidden">
              <img src="https://customer-assets-jt897jd0.emergentagent.net/job_temple-booking-hub-4/artifacts/a6054c377532a45a_images.png" alt="TTD Logo" className="w-11 h-11 object-contain" />
            </div>
            <div className="leading-tight">
              <div className="font-cinzel text-amber-50 text-lg sm:text-2xl font-bold tracking-wide">Tirumala Tirupati Devasthanams</div>
              <div className="text-amber-200/90 text-[10px] sm:text-xs uppercase tracking-widest">Official Online Booking Portal</div>
            </div>
          </Link>
          <button className="lg:hidden text-amber-100" onClick={() => setOpen(!open)} data-testid="mobile-menu-btn">
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>

      {/* Nav bar */}
      <nav className="backdrop-blur-md bg-[#7A0016]/95 border-b border-[#DAA520]/30 shadow-md">
        <div className={`max-w-7xl mx-auto px-4 ${open ? "block" : "hidden"} lg:block`}>
          <ul className="flex flex-col lg:flex-row lg:items-center gap-0 lg:gap-1">
            {NAV.map((n) => {
              const active = location.pathname === n.to;
              return (
                <li key={n.label}>
                  <Link
                    to={n.to}
                    onClick={() => setOpen(false)}
                    data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className={`block px-4 py-3 text-sm font-semibold uppercase tracking-wide transition-colors ${
                      active ? "text-[#50000E] bg-[#DAA520]" : "text-amber-100 hover:bg-[#DAA520]/20 hover:text-white"
                    }`}
                  >
                    {n.label}
                  </Link>
                </li>
              );
            })}
            <li className="lg:ml-auto">
              {admin ? (
                <button
                  onClick={() => { logout(); navigate("/"); }}
                  data-testid="header-logout-btn"
                  className="flex items-center gap-2 px-4 py-3 text-sm font-semibold text-amber-100 hover:text-white"
                >
                  <LogOut className="w-4 h-4" /> Logout
                </button>
              ) : (
                <Link
                  to="/admin"
                  className="flex items-center gap-2 px-4 py-3 text-sm font-semibold text-[#DAA520] hover:text-amber-200"
                  data-testid="header-admin-link"
                >
                  <ShieldCheck className="w-4 h-4" /> Admin Login
                </Link>
              )}
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
};
